import { loadECGWaveform } from '../../../utilities/ECGUtilities.js';
import { getGenericViewportSourceDataId } from '../genericViewportDisplaySetAccess.js';
export class DefaultECGDataProvider {
    async load(dataId) {
        const sourceDataId = getGenericViewportSourceDataId(dataId);
        const { waveform } = await loadECGWaveform(sourceDataId);
        return {
            id: dataId,
            type: 'ecg',
            ...waveform,
        };
    }
}
